import { render } from "./Alumnuses.vue?vue&type=template&id=5da14394&scoped=true&ts=true"
import script from "./Alumnuses.vue?vue&type=script&lang=ts"
export * from "./Alumnuses.vue?vue&type=script&lang=ts"

import "./Alumnuses.vue?vue&type=style&index=0&id=5da14394&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da14394"]])

export default __exports__